var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTelegramMax = function SvgTelegramMax(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#27A6E8",
    fillRule: "evenodd",
    d: "M29.333 16c0 7.364-5.97 13.333-13.334 13.333-7.363 0-13.333-5.97-13.333-13.333 0-7.364 5.97-13.333 13.333-13.333 7.364 0 13.334 5.97 13.334 13.333zm-8.247-5.434s-3.006 1.234-3.892 1.619c-2.312.963-8.979 3.7-8.979 3.7-1.58.616-.655 1.194-.655 1.194s1.349.462 2.505.81c1.156.346 1.773-.04 1.773-.04s2.697-1.772 5.433-3.66c1.927-1.31 1.464-.231 1.002.231a148.032 148.032 0 0 1-4.046 3.854c-.617.54-.309 1.002-.039 1.233.784.663 2.63 1.87 3.47 2.418.233.153.389.254.422.28.193.153 1.272.847 1.927.693.655-.154.732-1.04.732-1.04s.501-3.16.964-6.05c.085-.568.17-1.123.25-1.641.208-1.347.377-2.44.405-2.83.115-1.31-1.272-.77-1.272-.77z",
    clipRule: "evenodd"
  })));
};
export default SvgTelegramMax;